import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Software">
                <h1>Healthcare Software Development Services</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol has successfully offered healthcare software
                  development services with an in-depth understanding of
                  healthcare processes and industry standards. Our HTD approach
                  focuses on designing technology solutions with profound
                  comprehension of human preferences and behavior. We excel in
                  developing customized software solutions that address unique
                  challenges with;
                </p>
                <ul>
                  <li>Domain Expertise</li>
                  <li>Innovation and Technology</li>
                  <li>Collaborative Approach</li>
                  <li>Quality and Reliability</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
